import { render, staticRenderFns } from "./BookPeople.vue?vue&type=template&id=26c68d34&scoped=true&"
import script from "./BookPeople.vue?vue&type=script&lang=ts&"
export * from "./BookPeople.vue?vue&type=script&lang=ts&"
import style0 from "./BookPeople.vue?vue&type=style&index=0&id=26c68d34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c68d34",
  null
  
)

export default component.exports